// Most used two level domains in Mable
export const TOP_TWO_LEVEL_MABLE_SOURCE_URL_DOMAINS = [
  'thetrackreviews.com',
  'bounceexchange.com',
  'pinterest.com',
  'google.lu',
  'hello-charles.com',
  'speisekarte.de',
  'replo.app',
  'reviews.io',
  'sistrix.com',
  'storecategory.com',
  'fastbundle.co',
  'gutscheine4free.de',
  'shopifypreview.com',
  'gokarla.io',
  'naturalx.vc',
  'google.se',
  'microsoftonline.com',
  'claimlane.com',
  'gmx.net',
  'merkur.de',
  'gutscheine7.de',
  'cloudfront.net',
  'live.com',
  'google.hu',
  'orange.fr',
  'mitvergnuegen.com',
  'mail.ru',
  'taboola.com',
  'intercom.com',
  'convert.com',
  'nachhaltigejobs.de',
  'google.cl',
  'gutscheinsammler.de',
  'promocodie.com',
  'gocashback.com',
  'whensarasmiles.nl',
  'jobrad.org',
  'google.be',
  'rewardany.com',
  'shoptastic.io',
  'mybacs.com',
  'qwant.com',
  'elaine-asp.de',
  'wildschytz.com',
  'brunathelabel.com',
  'dealam.com',
  'mydealz.de',
  'leniisst.de',
  'lesnumeriques.com',
  'neona.store',
  'asana.com',
  'ecosia.org',
  'meinonlinewunschzettel.de',
  'returnsportal.online',
  'bt.com',
  'klarna.com',
  'stylink.it',
  'whowhatwear.com',
  'linkslist.app',
  'instagram.com',
  'stylink.com',
  'google.pt',
  'hispeed.ch',
  'coupons.de',
  'abconvert.io',
  'google.de',
  'klaviyo.com',
  'a1.net',
  'vorteile.net',
  'wl.co',
  'shopify.com',
  'yahoo.com',
  'msn.com',
  'trustwave.com',
  'twitch.tv',
  'trendmicro.com',
  'facebook.com',
  'searchfor.org',
  'focus.de',
  'sparwelt.de',
  'gorgias.help',
  'fitlaura.de',
  'googlesyndication.com',
  'google.ie',
  'shoop.de',
  'futurebens.co',
  'shooter-bubble.de',
  'shoplooks.com',
  'web.de',
  'google.fr',
  'google.ro',
  'popular-trends.com',
  'privacywall.org',
  'gutscheine.de',
  'instyle.de',
  'typeform.com',
  'tracdelight.io',
  'leslunes.com',
  't-online.de',
  'cntraveller.de',
  'tiktok.com',
  'igraal.com',
  'inspiredtoday.net',
  'edis.at',
  'cosmopolitan.de',
  'google.nl',
  'hotdeals.com',
  'stripe.com',
  'urbia.de',
  'eleasa.de',
  'gq-magazin.de',
  'google.ru',
  'startpage.com',
  'google.pl',
  'brigitte.de',
  'pippacampbellhealth.com',
  'freundin.de',
  'reddit.com',
  'linkedin.com',
  'petalsearch.com',
  'sushi-bikes.com',
  'google.it',
  'google.dk',
  'getalma.eu',
  'google.sk',
  'google.com',
  'elle.de',
  'myshopify.com',
  'google.ch',
  'google.at',
  'coupert.com',
  'harpersbazaar.de',
  'translate.goog',
  'kreatory.com',
  'championsclub.de',
  'zendesk.com',
  'sunrise.ch',
  'euspy.app',
  'google.ca',
  'bunte.de',
  'molops.net',
  'leslunes.us',
  'uk.latestfreestuffapp',
  'mail.com',
  'meinbezirk.at',
  'brave.com',
  'addsauce.com',
  'google.lt',
  'googleadservices.com',
  'freenet.de',
  'lifestyle-insights.com',
  'web-explore.com',
  'vodafone.de',
  'karmanow.com',
  'centrum.sk',
  'bing.com',
  'rainbowcoupons.com',
  'influencercoupons.com',
  'hotukdeals.com',
  'perplexity.ai',
  'wishsite.de',
  'shopback.de',
  'getarpu.com',
  'seznam.cz',
  'youtube.com',
  'advancesimple.com',
  'mein-dienstrad.de',
  'yotpo.com',
  'nativeinfoline.com',
  'mesenvies.fr',
  'healthwealthinsights.com',
  'glamour.de',
  'googleapis.com',
  'practicebetter.io',
  'promospro.de',
  'google.es',
  'trustpilot.com',
  'nocake.de',
  'helpscout.net',
];

// Most used two level domains in the public internet
export const TOP_USED_TWO_LEVEL_DOMAINS = [
  'ac.th',
  'gov.ar',
  'ac.uk',
  'org.in',
  'org.tw',
  'gov.ru',
  'edu.eg',
  'org.br',
  'com.tr',
  'edu.tw',
  'com.sg',
  'gob.mx',
  'go.id',
  'gov.uk',
  'net.br',
  'com.eg',
  'gov.au',
  'net.in',
  'com.au',
  'net.cn',
  'org.my',
  'co.za',
  'com.pt',
  'co.jp',
  'com.ar',
  'co.nz',
  'com.sa',
  'go.kr',
  'gov.ph',
  'edu.ru',
  'net.ru',
  'org.cn',
  'edu.au',
  'co.th',
  'or.id',
  'gov.sg',
  'go.jp',
  'com.ph',
  'org.tr',
  'gov.br',
  'gov.tr',
  'com.pl',
  'com.ru',
  'org.nz',
  'gov.sa',
  'co.il',
  'gov.il',
  'com.br',
  'co.uk',
  'edu.ph',
  'gov.za',
  'ac.id',
  'com.mx',
  'go.th',
  'org.za',
  'ac.nz',
  'ac.in',
  'net.za',
  'ac.kr',
  'gov.my',
  'co.kr',
  'net.au',
  'com.cn',
  'gov.pl',
  'co.id',
  'org.au',
  'gov.eg',
  'com.my',
  'co.in',
  'govt.nz',
  'org.sg',
  'gov.cn',
  'gov.tw',
  'org.mx',
  'com.tw',
  'org.il',
  'or.kr',
  'org.ru',
  'or.th',
  'or.jp',
  'gov.pt',
  'org.uk',
  'org.sa',
  'gov.in',
  'ac.jp',
];

export const COMMON_TWO_LEVEL_DOMAINS = [
  ...TOP_TWO_LEVEL_MABLE_SOURCE_URL_DOMAINS,
  ...TOP_USED_TWO_LEVEL_DOMAINS,
];
